import CheckBoxSuccess from '@assets/images/checkboxSuccess.png';
import useLanguageNavigate from '@hooks/useLanguageNavigate';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function SpecialistSuccess({ specialistFullName }: any) {
	const { t } = useTranslation();
	const { navigateWithLanguage } = useLanguageNavigate();

	return (
		<div className="w-full flex flex-col gap-[30px] justify-center items-center h-screen">
			<div className="flex flex-row items-center gap-[10px]">
				<div className="w-full h-full max-w-[42px]">
					<img src={CheckBoxSuccess} alt="checkbox_success" />
				</div>
				<span className="font-roboto text-primary text-xl font-bold">
					{t('specialistSelected')}
				</span>
			</div>
			<p
				className="font-roboto text-base font-normal text-light-grey"
				dangerouslySetInnerHTML={{
					__html: t('selectSpecialistMessage', { fullName: specialistFullName }),
				}}
			/>

			<Button
				className="w-full max-w-xs"
				variant="contained"
				onClick={() => navigateWithLanguage('/farmer/monitoring/ongoing-projects')}
			>
				{t('goToMonitoringProtocols')}
			</Button>
		</div>
	);
}
